import React from 'react';

import { applyCdnUrl } from '../utils/site-utils';

export var isRestricted = function(){
    // copied from 2.0 Device.ts
    var userAgent=navigator.userAgent.toLowerCase();
    return !userAgent.match(/edge\/([\d.]+)/i)
            && (
                userAgent.match(/rv:([\d.]+)\) like gecko/)
                ||
                userAgent.match(/msie ([\d.]+)/)
            )
}
export function BrowserRestrictWarning({lang, toggle}){
    var date="08/21/2020";
    return (
        <div className="popupPanel-upgrade">
            <div className="popupPanel-upgrade__heading">
                <div className="floatRight">
                    <div 
                        className="glyphIcon-large secondary icon-close"
                        onClick={toggle}
                    />
                </div>
            </div>
            <div className="popupPanel-upgrade__contentArea">
                <div className="browser-upgrade-panel">
                    <div className="text">
                    {
                        (/cs/i.test(lang) || /ch/i.test(lang) || /zhcn/i.test(lang))?(
                            <div className="text-group">
                                <h1>请升级您的浏览器</h1>
                                <p>我们将于 <span className="text-highlight">{date}</span> 起终止支持Internet Explorer。
                                </p>
                                <p>请使用其他浏览器,已获得最佳浏览体验。</p>
                            </div>
                        ):(/id/i.test(lang))?(
                            <div className="text-group">
                                <h1>Tingkatkan Browser untuk Pengalaman Penuh</h1>
                                <p>Kami berencana untuk mengakhiri dukungan kami untuk Internet Explorer pada <span className="text-highlight">{date}</span> Untuk mendapatkan pengalaman terbaik bersama kami,
                                </p>
                                <p>pastikan Anda menggunakan salah satu browser yang didukung ini. </p>
                            </div>
                        ):(/vn/i.test(lang))?(
                            <div className="text-group">
                                <h1>Nâng cấp trình duyệt để có trải nghiệm tốt nhất</h1>
                                <p>Chúng tôi sẽ chấm dứt hỗ trợ cho Internet Explorer từ ngày <span className="text-highlight">{date}</span> Để có được trải nghiệm tốt nhất với chúng tôi,
                                </p>
                                <p>hãy đảm bảo rằng bạn đang sử dụng một trong những trình duyệt được hỗ trợ này.</p>
                            </div>
                        ):(
                            <div className="text-group">
                                <h1>Upgrade Browser for Full Experience</h1>
                                <p>We are planning to end our support for 
                                    <br/>Internet Explorer on <span className="text-highlight">{date}</span> 
                                </p>
                                <p>To get the best experience with us, make sure you are using one of these supported browsers.</p>
                            </div> 
                        )
                    }
                    </div>
                </div>
                <div class="browser-upgrade-download" data-tag="tagBrowserDownload">
                    <div className="download-item">
                        <img src={applyCdnUrl('/NewAsiaSkin/CommIndex/_global-L/public/images/BrowserUpgrade/logo_Edge.png')} />
                        <a className="btn" target="_blank" href="https://www.microsoft.com/zh-tw/edge">
                            <div className="icon-download-outline"></div>
                            <span className="text">Edge</span>
                        </a>
                    </div>
                    <div className="download-item">
                        <img src={applyCdnUrl('/NewAsiaSkin/CommIndex/_global-L/public/images/BrowserUpgrade/logo_Chrome.png')} />
                        <a className="btn" target="_blank" href="https://www.google.com/intl/zh-TW/chrome/">
                            <div className="icon-download-outline"></div>
                            <span className="text">Chrome</span>
                        </a>
                    </div>
                    <div className="download-item">
                        <img src={applyCdnUrl('/NewAsiaSkin/CommIndex/_global-L/public/images/BrowserUpgrade/logo_firefox.png')} />
                        <a className="btn" target="_blank" href="https://www.mozilla.org/zh-TW/firefox/new/">
                            <div className="icon-download-outline"></div>
                            <span className="text">Firefox</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    )
}